import apiClient from "../utils/apiClient";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useMyContext } from "../context";
import useFilter from "../hooks/useFilter";
import Swal from "sweetalert2";

const useLogs = ({ adminId } = {}) => {
  const queryClient = useQueryClient();
  const { id, comment, handleCloseModal, showErrorAlert } = useMyContext();
  const { date, action, page, search } = useFilter();
  const { data, error, isError, isLoading } = useQuery({
    queryKey: ["logs", adminId, date, action, page, search],
    queryFn: async () => {
      // Create URLSearchParams object to handle query parameters
      const params = new URLSearchParams();

      // Only add adminId parameter if adminId is provided and is truthy
      if (adminId) {
        params.append("adminId", adminId);
      }

      // Add date parameter if exists and is not empty
      if (date && date.trim() !== "") {
        params.append("date", date);
      }

      // Add action parameter if exists and is not empty
      if (action && action.trim() !== "") {
        params.append("action", action);
      }
      if (page) {
        params.append("page", page);
      }
      if (search) {
        params.append("search", search);
      }
      // Build the URL with proper query parameter handling
      let url = "/dashboard/audit-logs";
      if (params.toString()) {
        url += `?${params.toString()}`;
      }

      const res = await apiClient.get(url);
      return res.data;
    },
    // Enable the query only if we have either adminId, date, or action
    // Or if we want to fetch all logs when no filters are applied
    enabled: true, // Or you can conditionally enable it: !!(adminId || date || action)
  });

  // get log by id
  const {
    data: logById,
    error: logByIdError,
    isError: logByIdIsError,
    isLoading: logByIdLoading,
  } = useQuery({
    queryKey: ["logById", id],
    queryFn: async () => {
      const res = await apiClient.get(`/dashboard/audit-logs/${id}`);
      return res.data;
    },
    // Only fetch log by id when id exists
    enabled: !!id,
  });
  // add comment
  const addComment = useMutation({
    mutationFn: async () => {
      const res = await apiClient.post(`/dashboard/audit-logs/${id}/comments`, {
        comment: comment,
      });
      return res.data;
    },
    onSuccess: () => {
      Swal.fire({
        icon: "success",
        title: "Comment added successfully",
        showConfirmButton: false,
        timer: 1500,
      });
      handleCloseModal("addComment");
      queryClient.invalidateQueries({ queryKey: ["logById"] });
    },
    onError: (err) => {
      showErrorAlert(err, "error");
    },
  });
  const addCommentLoading = addComment.isLoading;
  const handleAddComment = () => {
    addComment.mutate();
  };
  return {
    data,
    error,
    isError,
    isLoading,
    logById,
    logByIdError,
    logByIdIsError,
    logByIdLoading,
    addCommentLoading,
    handleAddComment,
  };
};
export default useLogs;
